// app_client/src/store/useModuleStore.js
import { create } from 'zustand';
import axios from 'axios';
import { toast } from 'react-hot-toast';

const useModuleStore = create((set, get) => ({
  modules: [],
  loading: false,

  fetchModules: async () => {
    set({ loading: true });
    try {
      const response = await axios.get('/api/modules');
      set({ modules: response.data, loading: false });
    } catch {
      toast.error("Modüller yüklenemedi");
      set({ loading: false });
    }
  },

  createModule: async (moduleData) => {
    const { data } = await axios.post('/api/modules', moduleData);
    set((state) => ({
      modules: [...state.modules, data].sort((a, b) => a.label.localeCompare(b.label))
    }));
    return data;
  },

  toggleModuleStatus: async (id, currentStatus) => {
    try {
      const response = await axios.put(`/api/modules/${id}`, { isActive: !currentStatus });
      set({
        modules: get().modules.map(m => m._id === id ? response.data : m)
      });
      toast.success(`Modül ${!currentStatus ? 'Aktif' : 'Pasif'} yapıldı`);
    } catch {
      toast.error("Durum güncellenemedi");
    }
  }
}));

export default useModuleStore;